import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getMessaging, isSupported } from 'firebase/messaging';

const environment = import.meta.env.VITE_ENVIRONMENT || 'development';
const isLocalEnvironment = environment === 'local' || environment === 'development';

const firebaseConfigFromEnv = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const hasFirebaseCredentials = Object.values(firebaseConfigFromEnv).every(
  (value) => typeof value === 'string' && value.trim().length > 0
);

export const firebaseConfig = hasFirebaseCredentials
  ? firebaseConfigFromEnv
  : {
      apiKey: 'local-dev',
      authDomain: 'local-dev.firebaseapp.com',
      databaseURL: 'https://local-dev.firebaseio.com',
      projectId: 'local-dev',
      storageBucket: 'local-dev.appspot.com',
      messagingSenderId: '000000000000',
      appId: '1:000000000000:web:localdev',
    };

if (!hasFirebaseCredentials && !isLocalEnvironment) {
  throw new Error('Firebase env variables are required when VITE_ENVIRONMENT is not local/development');
}

if (!hasFirebaseCredentials && isLocalEnvironment) {
  // eslint-disable-next-line no-console
  console.warn('Firebase env variables are missing. Using local fallback config.');
}

const app = initializeApp(firebaseConfig);

export const messaging = hasFirebaseCredentials
  ? isSupported()
      .then((supported) => (supported ? getMessaging(app) : null))
      .catch(() => null)
  : Promise.resolve(null);
export const auth = getAuth(app);
export const db = getDatabase(app);

export const vapidKey = import.meta.env.VITE_FIREBASE_VAPID_KEY as string | undefined;
